<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      :color="leftDrawerColor"
      :mini-variant="miniVariant"
      :x-small="true"
      app
      dark
      width="300"
      mini-variant-width="100"
      enable-resize-watcher
      class="d-print-none"
    >
      <v-list nav>
        <v-list-item three-line>
          <v-list-item-content class="d-flex justify-center">
            <v-img
              :src="logo"
              alt="AGIL"
              class="mx-2"
              max-width="60"
              max-height="60"
            >
            </v-img>
            <v-list-item-title
              class="d-flex justify-center"
              style="text-transform: uppercase"
              v-if="!miniVariant"
              >La filière laitière française</v-list-item-title
            >
            <v-list-item-subtitle class="d-flex text-center" v-if="!miniVariant"
              >Annuaire Général de l'Interprofession
              Laitière</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>

        <!-- Menu utilisateur lambda -->
        <template v-if="$auth.logged()">
          <v-tooltip
            top
            v-if="$auth.mayNavigateTo({ name: 'recherche/recherchesimple' })"
          >
            <template #activator="{ on: onTooltip }">
              <v-list-item
                :to="{ name: 'recherche/recherchesimple' }"
                v-on="{ ...onTooltip }"
              >
                <v-list-item-icon>
                  <v-icon>mdi-magnify</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{
                  $t('menu.recherche.rechercheSimple')
                }}</v-list-item-title>
              </v-list-item>
            </template>
            <span>{{ $t('menu.recherche.rechercheSimple') }}</span>
          </v-tooltip>

          <v-divider></v-divider>
          <v-tooltip
            top
            v-if="$auth.mayNavigateTo({ name: 'recherche/rechercheavancee' })"
          >
            <template #activator="{ on: onTooltip }">
              <v-list-item
                :to="{ name: 'recherche/rechercheavancee' }"
                v-on="{ ...onTooltip }"
              >
                <v-list-item-icon>
                  <v-icon>mdi-magnify-plus-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{
                  $t('menu.recherche.rechercheAvancee')
                }}</v-list-item-title>
              </v-list-item>
            </template>
            <span>{{ $t('menu.recherche.rechercheAvancee') }}</span>
          </v-tooltip>

          <v-divider></v-divider>

          <v-list-group
            color="white"
            append-icon=""
            v-if="
              hasDemandeCreationPersonnePhysique ||
                hasDemandeCreationPersonneMorale ||
                hasDemandeCreationInstance
            "
          >
            <template #activator>
              <v-tooltip top>
                <template #activator="{ on: onTooltip }">
                  <v-list-item v-on="{ ...onTooltip }" class="pa-0">
                    <v-list-item-icon>
                      <v-icon>mdi-file-plus-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{
                      $t('menu.workflow.demande.creation.title')
                    }}</v-list-item-title>
                  </v-list-item>
                </template>
                <span>{{ $t('menu.workflow.demande.creation.title') }}</span>
              </v-tooltip>
            </template>

            <v-tooltip top v-if="hasDemandeCreationPersonnePhysique">
              <template #activator="{ on: onTooltip }">
                <v-list-item
                  :to="{ name: 'demandecreation/personnephysique' }"
                  v-on="{ ...onTooltip }"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{
                    $t('menu.workflow.demande.creation.titlePersonnePhysique')
                  }}</v-list-item-title>
                </v-list-item>
              </template>
              <span>{{
                $t('menu.workflow.demande.creation.titlePersonnePhysique')
              }}</span>
            </v-tooltip>

            <v-tooltip top v-if="hasDemandeCreationPersonnePhysique">
              <template #activator="{ on: onTooltip }">
                <v-list-item
                  :to="{ name: 'workflow/creation-masse-contact' }"
                  v-on="{ ...onTooltip }"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-account-group</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{
                    $t('personnePhysique.creation-masse.title')
                  }}</v-list-item-title>
                </v-list-item>
              </template>
              <span>{{ $t('personnePhysique.creation-masse.title') }}</span>
            </v-tooltip>

            <v-tooltip top v-if="hasDemandeCreationPersonneMorale">
              <template #activator="{ on: onTooltip }">
                <v-list-item
                  :to="{ name: 'demandecreation/personnemorale' }"
                  v-on="{ ...onTooltip }"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-domain</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{
                    $t('menu.workflow.demande.creation.titlePersonneMorale')
                  }}</v-list-item-title>
                </v-list-item>
              </template>
              <span>{{
                $t('menu.workflow.demande.creation.titlePersonneMorale')
              }}</span>
            </v-tooltip>

            <v-tooltip top v-if="hasDemandeCreationInstance">
              <template #activator="{ on: onTooltip }">
                <v-list-item
                  :to="{ name: 'demandecreation/instance' }"
                  v-on="{ ...onTooltip }"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-notebook-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{
                    $t('menu.workflow.demande.creation.titleInstance')
                  }}</v-list-item-title>
                </v-list-item>
              </template>
              <span>{{
                $t('menu.workflow.demande.creation.titleInstance')
              }}</span>
            </v-tooltip>
          </v-list-group>

          <v-divider></v-divider>

          <v-list-group
            color="white"
            append-icon=""
            v-if="
              $auth.mayNavigateTo({ name: 'creation/personnephysique' }) ||
                $auth.mayNavigateTo({ name: 'creation/personnemorale' }) ||
                $auth.mayNavigateTo({ name: 'workflow/remplacer-contact' }) ||
                $auth.mayNavigateTo({ name: 'creation/instance' })
            "
          >
            <template #activator>
              <v-tooltip top>
                <template #activator="{ on: onTooltip }">
                  <v-list-item v-on="{ ...onTooltip }" class="pa-0">
                    <v-list-item-icon>
                      <v-icon>mdi-cog-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Gestion
                    </v-list-item-title>
                  </v-list-item>
                </template>
                <span>Gestion</span>
              </v-tooltip>
            </template>

            <template
              v-if="$auth.mayNavigateTo({ name: 'workflow/remplacer-contact' })"
            >
              <v-divider></v-divider>

              <v-tooltip top>
                <template #activator="{ on: onTooltip }">
                  <v-list-item
                    :to="{ name: 'workflow/remplacer-contact' }"
                    v-on="{ ...onTooltip }"
                  >
                    <v-list-item-icon>
                      <v-icon>mdi-account-arrow-right</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      {{ $t('personnePhysique.remplacerContact.title') }}
                    </v-list-item-title>
                  </v-list-item>
                </template>
                <span>{{ $t('personnePhysique.remplacerContact.title') }}</span>
              </v-tooltip>
            </template>

            <v-tooltip
              top
              v-if="
                $auth.mayNavigateTo({
                  name: 'creation/personnephysique',
                })
              "
            >
              <template #activator="{ on: onTooltip }">
                <v-list-item
                  :to="{ name: 'creation/personnephysique' }"
                  v-on="{ ...onTooltip }"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{
                    $t('personnePhysique.creation.title')
                  }}</v-list-item-title>
                </v-list-item>
              </template>
              <span>{{ $t('personnePhysique.creation.title') }}</span>
            </v-tooltip>
            <v-tooltip
              top
              v-if="
                $auth.mayNavigateTo({
                  name: 'creation/personnemorale',
                })
              "
            >
              <template #activator="{ on: onTooltip }">
                <v-list-item
                  :to="{ name: 'creation/personnemorale' }"
                  v-on="{ ...onTooltip }"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-domain</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{
                    $t('personneMorale.creation.title')
                  }}</v-list-item-title>
                </v-list-item>
              </template>
              <span>{{ $t('personneMorale.creation.title') }}</span>
            </v-tooltip>

            <v-tooltip
              top
              v-if="
                $auth.mayNavigateTo({
                  name: 'creation/instance',
                })
              "
            >
              <template #activator="{ on: onTooltip }">
                <v-list-item
                  :to="{ name: 'creation/instance' }"
                  v-on="{ ...onTooltip }"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-notebook-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{
                    $t('instance.creation.title')
                  }}</v-list-item-title>
                </v-list-item>
              </template>
              <span>{{ $t('instance.creation.title') }}</span>
            </v-tooltip>
          </v-list-group>

          <template v-if="$auth.mayNavigateTo({ name: 'workflow/demande' })">
            <v-divider></v-divider>

            <v-tooltip top>
              <template #activator="{ on: onTooltip }">
                <v-list-item
                  :to="{ name: 'workflow/demande' }"
                  v-on="{ ...onTooltip }"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-file-document-edit-outline</v-icon>
                    <compteurDemandeBadge />
                  </v-list-item-icon>
                  <v-list-item-title>
                    {{ $t('menu.workflow.demande.validation.title') }}
                  </v-list-item-title>
                </v-list-item>
              </template>
              <span>{{ $t('menu.workflow.demande.validation.title') }}</span>
            </v-tooltip>
          </template>
        </template>

        <!-- Menu Login -->
        <template v-if="!$auth.logged()">
          <v-list-item-group>
            <v-list-item :to="{ name: 'home' }">
              <v-list-item-content class="d-flex justify-center">
                <v-list-item-title class="d-flex justify-center"
                  >{{ $t('menu.signin') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-card-text>
              <v-form @keyup.native.enter="login">
                <v-text-field
                  solo
                  light
                  :error-messages="$errors($v.loginForm.login)"
                  v-model="$v.loginForm.login.$model"
                  :label="$t('login.form.id')"
                  autofocus
                />
                <v-text-field
                  solo
                  light
                  :error-messages="$errors($v.loginForm.password)"
                  v-model="$v.loginForm.password.$model"
                  :label="$t('login.form.password')"
                  type="password"
                />
              </v-form>
              <v-btn
                block
                center
                :loading="loginForm.loading"
                color="secondary"
                class="mb-3"
                @click="login"
                >{{ $t('login.form.button.login') }}</v-btn
              >

              <v-list-item
                class="mt-3 white--text text-center"
                :to="{ name: 'recoverPassword' }"
              >
                Mot de passe oublié ?
              </v-list-item>
            </v-card-text>
            <v-divider />
            <v-list-item :to="{ name: 'subscribe' }">
              <v-list-item-content class="d-flex justify-center">
                <v-list-item-title class="d-flex justify-center">{{
                  $t('menu.subscribe')
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      v-if="$auth.logged()"
      dense
      app
      flat
      color="white"
      class="d-print-none"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <bread-crumb />
    </v-app-bar>
    <v-main class="mainContent">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </v-main>

    <v-navigation-drawer
      v-if="$auth.logged()"
      v-model="drawer"
      :color="contentNavigationDrawerRight"
      :mini-variant="miniVariant"
      :x-small="true"
      right
      class="elevation-2 d-print-none"
      app
      mini-variant-width="100"
    >
      <v-list-item
        class="headerNavigationDrawerRight pt-0 pa-3"
        color="white"
        flat
        disabled
      >
        <v-list-item-content>
          <template v-if="miniVariant">
            <p class="sizeTextfooter text-center mb-2 date">
              {{ computedDateFormattedMomentMinijs }}
            </p>

            <p></p>
            <p class="sizeTextfooter text-center ">
              Bienvenue
            </p>
            <p class="sizeTextfooter text-center">
              {{ $auth.nomComplet() }}
            </p>
          </template>
          <template v-if="!miniVariant">
            <p class="mb-2 date">
              {{ computedDateFormattedMomentjs }}
            </p>

            <p></p>
            <p>Bienvenue {{ $auth.nomComplet() }}</p>
          </template>
        </v-list-item-content>
      </v-list-item>
      <v-list dense>
        <v-row
          nav
          dense
          class="containestyle"
          :color="contentNavigationDrawerRight"
        >
          <v-list-item
            class="borderTextNavigationDrawRight "
            @click.stop="miniVariant = !miniVariant"
            link
          >
            <v-list-item-icon>
              <v-icon class="colorIconTextNavigationDraw" v-if="!miniVariant"
                >mdi-arrow-left-right-bold
              </v-icon>
              <v-icon
                class="colorIconTextNavigationDraw"
                v-if="miniVariant"
                @click.exact="miniVariant = miniVariant"
                >mdi-arrow-expand-all
              </v-icon>
            </v-list-item-icon>

            <v-list-item-title
              class="sizeTextContent colorIconTextNavigationDraw"
              >{{ $t('menu.reduire') }}</v-list-item-title
            >
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item
            class="borderTextNavigationDrawRight"
            :to="{ name: 'changepassword' }"
          >
            <v-list-item-icon>
              <v-icon class="colorIconTextNavigationDraw"
                >mdi-account-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              class="sizeTextContent colorIconTextNavigationDraw"
              >{{ $t('menu.monCompte') }}</v-list-item-title
            >
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item
            class="borderTextNavigationDrawRight"
            :to="{ name: 'recherche/mesinstances' }"
            v-if="$auth.mayNavigateTo({ name: 'recherche/mesinstances' })"
          >
            <v-list-item-icon>
              <v-icon class="colorIconTextNavigationDraw"
                >mdi-notebook-outline</v-icon
              >
            </v-list-item-icon>
            <v-list-item-title
              class="sizeTextContent colorIconTextNavigationDraw"
              >{{ $t('menu.instances') }}</v-list-item-title
            >
          </v-list-item>

          <v-list-item
            class="borderTextNavigationDrawRight"
            :to="{ name: 'recherche/mesrecherchesavancees' }"
            v-if="
              $auth.mayNavigateTo({ name: 'recherche/mesrecherchesavancees' })
            "
          >
            <v-list-item-icon>
              <v-icon class="colorIconTextNavigationDraw"
                >mdi-magnify-plus-outline</v-icon
              >
            </v-list-item-icon>
            <v-list-item-title
              class="sizeTextContent colorIconTextNavigationDraw"
              >{{
                $t('menu.recherche.mesRecherchesAvancees')
              }}</v-list-item-title
            >
          </v-list-item>

          <v-divider></v-divider>
          <v-list-item
            class="borderTextNavigationDrawRight"
            :to="{ name: 'workflow/mesdemandes' }"
            v-if="$auth.mayNavigateTo({ name: 'workflow/mesdemandes' })"
          >
            <v-list-item-icon>
              <v-icon class="colorIconTextNavigationDraw"
                >mdi-file-document-edit-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              class="sizeTextContent colorIconTextNavigationDraw"
              >{{ $t('menu.mesDemandes') }}</v-list-item-title
            >
          </v-list-item>

          <v-divider></v-divider>
          <v-list-item
            class="borderTextNavigationDrawRight"
            lin
            :to="{ name: 'administration/home' }"
            v-if="$auth.mayNavigateTo({ name: 'administration/home' })"
          >
            <v-list-item-icon>
              <v-icon class="colorIconTextNavigationDraw"
                >mdi-cog-outline</v-icon
              >
            </v-list-item-icon>
            <v-list-item-title
              class="sizeTextContent colorIconTextNavigationDraw"
              >{{ $t('menu.parametres') }}</v-list-item-title
            >
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item
            class="borderTextNavigationDrawRight"
            @click="logout"
            link
          >
            <v-list-item-icon>
              <v-icon class="colorIconTextNavigationDraw"
                >mdi-close-circle-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              class="sizeTextContent colorIconTextNavigationDraw"
            >
              {{ $t('menu.signout') }}</v-list-item-title
            >
          </v-list-item>
          <v-divider></v-divider>
        </v-row>
      </v-list>
      <v-footer fixed color="secondary" dark>
        <v-row justify="center" no-gutters>
          <v-btn
            v-for="link in links"
            :key="link.value"
            color="white"
            text
            x-small
            rounded
            justify="center"
            :to="{ name: 'home/' + link.value }"
          >
            {{ link.text }}
          </v-btn>
          <a
            :href="publicPath + 'Charte Informatique MDL-2021.pdf'"
            style="text-decoration: none; color: inherit;"
            target="_blank"
          >
            <v-btn
              key="Charte"
              color="white"
              text
              x-small
              rounded
              justify="center"
            >
              Charte informatique MDL
            </v-btn>
          </a>
        </v-row>
        <v-row justify="center" class="text-center" x-small="true" cols="12">
          <div>
            <p
              :class="
                miniVariant ? 'sizeTextfooter text-center' : ' sizeTextfooter'
              "
            >
              {{
                miniVariant
                  ? 'AGIL'
                  : "Annuaire Général de l'Interprofession Laitière | AGIL"
              }}
              {{ new Date().getFullYear() }}
            </p>
            <p
              :class="
                miniVariant ? 'sizeTextfooter text-center' : ' sizeTextfooter'
              "
            >
              v{{ version.version }} build {{ hash }}
            </p>
          </div>
        </v-row>
      </v-footer>
    </v-navigation-drawer>
  </v-app>
</template>

<script>
import logo from '@/assets/images/logo.png';
import moment from 'moment';
import hash from '@/assets/hash.json';
import version from '@/assets/version.json';
import _ from 'lodash';
import { required } from 'vuelidate/lib/validators';
import CompteurDemandeBadge from '@/components/workflow/CompteurDemandeBadge';

export default {
  name: 'App',
  components: {
    compteurDemandeBadge: CompteurDemandeBadge,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      drawer: true,
      miniVariant: false,
      date: new Date().toISOString().substr(0, 10),
      links: [
        { text: 'Données personnelles', value: 'RGPD' },
        { text: 'Mentions légales', value: 'Mentions' },
      ],
      color: 'primary',
      colors: ['primary', 'blue', 'success', 'red', 'teal'],
      right: true,
      expandOnHover: false,
      background: false,
      subs: [],
      leftDrawer: {
        visible: true,
        mini: false,
        expandable: false,
      },
      rightDrawer: {
        visible: true,
        mini: true,
        expandable: true,
      },
      bottomPanel: {
        visible: true,
      },
      leftDrawerColor: 'primary',
      // leftDrawerColor: 'rgb(17,13,140)',         // Couleur de la maquette d'Obeyd, pas en phase avec le celle du logo
      rightDrawerColor: 'rgb(17,13,140)',
      rightDrawerTopColor: 'rgb(253,234,232)',
      rightDrawerCenterColor: 'rgb(243,250,255)',
      rightDrawerBottomColor: 'rgb(246,194,36)',
      bottomPanelColor: 'rgb(29,184,156)',
      headerNavigationDrawerRight: 'rgb(294, 194, 36)',
      contentNavigationDrawerRight: 'rgb(230, 245, 255)',
      footerNavigationDrawerRight: 'rgb(255, 204, 102)',
      logo,
      hash,
      version,
      loginForm: {
        login: '',
        password: '',
        loading: false,
      },
    };
  },
  watch: {
    $route(to) {
      this.watchRoute(to);
    },
    logged() {
      this.handleStompActivation();
    },
    accessToken() {
      this.$stomp.useToken(this.accessToken);
    },
  },
  mounted() {
    this.watchRoute(this.$route);
    this.handleStompActivation();
  },
  computed: {
    computedDateFormattedMomentjs() {
      var moment = require('moment');
      require('moment/locale/fr');
      return this.date
        ? _.capitalize(moment(this.date).format('dddd, DD MMMM YYYY'))
        : '';
    },
    computedDateFormattedMomentMinijs() {
      return this.date
        ? _.capitalize(moment(this.date).format('DD/MM/YYYY'))
        : '';
    },
    logged() {
      return this.$store.getters['oauth/logged'];
    },
    accessToken() {
      return this.$store.getters['oauth/access_token'];
    },
    hasDemandeCreationPersonnePhysique() {
      return (
        this.$auth.mayNavigateTo({
          name: 'demandecreation/personnephysique',
        }) && !this.$auth.mayNavigateTo({ name: 'creation/personnephysique' })
      );
    },
    hasDemandeCreationPersonneMorale() {
      return (
        this.$auth.mayNavigateTo({ name: 'demandecreation/personnemorale' }) &&
        !this.$auth.mayNavigateTo({ name: 'creation/personnemorale' })
      );
    },
    hasDemandeCreationInstance() {
      return (
        this.$auth.mayNavigateTo({ name: 'demandecreation/instance' }) &&
        !this.$auth.mayNavigateTo({ name: 'creation/instance' })
      );
    },
  },
  methods: {
    handleStompActivation() {
      if (
        this.logged &&
        this.$auth.mayNavigateTo({ name: 'workflow/demande' })
      ) {
        this.$stomp.connect(this.accessToken);
      } else {
        this.$stomp.deactivate();
      }
    },
    login() {
      this.$v.$touch();
      if (!this.$v.loginForm.$invalid) {
        this.loading = true;
        this.$auth
          .login(this.loginForm.login, this.loginForm.password)
          .finally(() => (this.loginForm.loading = false));
      }
    },
    logout() {
      this.$auth.logout();
      this.drawer = true;
      this.miniVariant = false;
    },
    watchRoute(to) {
      var title = 'menu.default';
      if (to.meta && to.meta.breadcrumb) {
        const rawBread = to.meta.breadcrumb(to);
        if (rawBread.length) {
          title = rawBread[rawBread.length - 1].code;
        }
      }
      this.title = title;
      this.hasDate = to.meta.globalDate || false;
      if (to.params.sidebar) {
        this.drawer = true;
      }
    },
  },
  validations: {
    loginForm: {
      login: {
        required,
      },
      password: {
        required,
      },
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Montserrat');

#app {
  font-family: 'Montserrat', sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@media print {
  main.v-main.mainContent {
    padding: 4px !important;
  }

  div.v-expansion-panel {
    break-inside: avoid;
  }
}

.headerNavigationDrawerRight {
  background: rgb(294, 194, 36) 0% 0% no-repeat padding-box;
}

.headerNavigationDrawerRight .date {
  border-bottom: 1px solid #ffffff;
}

li.disabled a {
  color: var(--v-secondary-base) !important;
}

.borderTextNavigationDrawRight {
  margin-bottom: 14px;
  margin-top: 8px;
}
.borderTextFooter {
  margin-bottom: 10px;
}

.sizeTextfooter {
  font-size: 0.65em;
  font-family: 'Montserrat', SemiBold, sans-serif;
}
.sizeTextContent {
  font-size: 15px;
}
.my-text-style >>> .v-text-field__slot input {
  color: #ea473e;
  font-family: 'Montserrat', regular, sans-serif;
}
.my-text-style-p {
  color: #ea473e;
  font-family: 'Montserrat', regular, sans-serif;
}
.colorIconTextNavigationDraw {
  color: #1db89c;
  font-family: 'Montserrat', regular, sans-serif;
}
</style>
